var map = {
	"./de-de.po": 1980,
	"./en-ca.po": 1981,
	"./en-gb.po": 1982,
	"./en-ie.po": 1983,
	"./en-us.po": 1984,
	"./es-es.po": 1985,
	"./es-mx.po": 1986,
	"./fr-ca.po": 1987,
	"./fr-fr.po": 1988,
	"./hr-hr.po": 1989,
	"./it-it.po": 1990,
	"./nl-nl.po": 1991,
	"./pl-pl.po": 1992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1950;
module.exports = webpackContext;